import {
  Arr
} from '../Array.lib';
import Core from '../Core';
import Engagement from '../Engagement';
import globalErrorHandler from '../Error/globalErrorHandler.fun';
import {
  COLLECTION__ENGAGEMENTS, readLoopbackRecord
} from '../services/BE/loopback.api';
import {
  compileText,
  trim
} from '../String.lib';

export default function onErrorBox({
  boxKey = '',
  tryTo = 'fetch Streak Box',
  defaultHandler = null,
}) {
  return async (error) => {
    try {
      Core.failure({ error, omitUIMessage: true });
      if (trim(error).match(/not found|bad encoded/i)) {
        const engagements = Arr(
          await readLoopbackRecord({
            collection: COLLECTION__ENGAGEMENTS,
            where: { boxKey },
          })
        );
        for (const engagement of engagements) {
          await Engagement.update(engagement, { boxKey: '' });
        }
        throw error;
      }
      else if (defaultHandler instanceof Function) {
        defaultHandler(error);
      }
      else {
        Core.failure({ error, omitUIMessage: true });
      }
    }
    catch (error) {
      globalErrorHandler(
        compileText(
          'Error: Trying to {{TRY_TO}} - {{ERROR}}\n\nPlease refresh the page',
          {
            TRY_TO: tryTo,
            ERROR: error
          }
        )
      );
    }
    return error;
  };
}
